import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'A collection of ideas captured and being implemented by Attain Innovation.',
    name: 'Innovation Ideas',
    partialId: PartialId.Standard.create('innovation_ideas'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
